@if(afficherChampDeConnexion0()){
<form [formGroup]="loginForm" (ngSubmit)="onSubmitForm()">
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <div class="logo-container" tuiHeader>
          <img src="assets/images/logo_synapse_2025.png" alt="Logo" class="logo" />
        </div>
        <div>
          <tui-input formControlName="username">
            Identifiant
            <input tuiTextfieldLegacy />
          </tui-input>
          <tui-error formControlName="username" [error]="[] | tuiFieldError | async" />
        </div>
        <div>
          <tui-input-password formControlName="password">Mot de passe</tui-input-password>
          <tui-error formControlName="password" [error]="[] | tuiFieldError | async" />
        </div>
        @if(afficherErreurDeConnexion0()){ <p>Identifiant ou mot de passe incorrect.</p> }
        <button size="m" tuiButton>Se connecter</button>
      </div>
    </div>
  </div>
</form>
}